import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import * as Yup from "yup";
import LakeSelectorMap from 'Components/MainMap/LakeSelectorMap';


//import images
import lake from "../../../assets/images/svg/lake.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useLakeCreateMutation, useLakeDeleteMutation, useLakeFindAllQuery, useLakeUpdateMutation, useLakeShapeFindAllQuery, useLakeShapeUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import AuInputList from "Components/Common/AuInputList";
import ImageUploader from "Components/fileUpload/ImageUploader";
import StatusSelect from "Components/Common/StatusSelect";

// const ELEVATION_API = 'https://api.open-elevation.com/api/v1/lookup';

// const getElevation = async (lat: number, lon: number): Promise<number> => {
//   const res = await fetch(
//     `${ELEVATION_API}?locations=${lat},${lon}`
//   );
//   const json = await res.json();
//   return json?.results?.[0]?.elevation ?? 0;
// };

const Detail = ({ searchField }: any) => {

  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useLakeFindAllQuery(customQuery);
  const [lakeCreate, lakeCreateResult] = useLakeCreateMutation();
  const [lakeUpdate, lakeUpdateResult] = useLakeUpdateMutation();
  const [lakeDelete, lakeDeleteResult] = useLakeDeleteMutation();

  const [lakeShapeUpdate, lakeShapeUpdateResult] = useLakeShapeUpdateMutation();


  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [modal_backdrop, setmodal_backdrop] = useState(false);

  const [lakeOne, setLakeOne] = useState<any>();
  const [lakeList, setLakeList] = useState<any>();
  const [lakeCount, setLakeCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();


  const [baseMap, setBaseMap] = useState<'openstreet' | 'voyager' | 'google' | 'topo'>("voyager")
  const [lakeBoolean, setLakeBoolean] = useState(true);
  const [lakeGeometry, setLakeGeometry] = useState<any>();
  const [lakeId, setLakeId] = useState<any>();
  const [lakeConvertId, setConvertLakeId] = useState<any>();

  const [lakeCrs, setLakeCrs] = useState<any>();
  const [isEditShape, setIsEditShape] = useState<any>(false);

  const [selectedLake, setSelectedLake] = useState<any>();


  const lakeFilter = {
    lakeBoolean: lakeBoolean,
  }

  const {
    data: commonLake,
    error: commonLakeError,
    isFetching: isCommonLakeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_lake_type`);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: lakeOne?.id,
      code: lakeOne?.code,
      name: lakeOne?.name,
      location: lakeOne?.location,
      cmn_lake_type: lakeOne?.cmn_lake_type,
      sea_level_m: lakeOne?.sea_level_m,

      basin_code: lakeOne?.basin_code ?? null,
      au1_code: lakeOne?.au1_code ?? null,
      au2_code: lakeOne?.au2_code ?? null,
      au3_code: lakeOne?.au3_code ?? null,

      longitude: lakeOne?.longitude ?? null,
      latitude: lakeOne?.latitude ?? null,

      status_id: lakeOne?.status_id ?? null,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();
        formData.append('id', lakeOne?.id);
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('location', values?.location);
        formData.append('cmn_lake_type', values?.cmn_lake_type);
        formData.append('sea_level_m', values?.sea_level_m);

        formData.append('basin_code', values?.basin_code);
        formData.append('au1_code', values?.au1_code);
        formData.append('au2_code', values?.au2_code);
        formData.append('au3_code', values?.au3_code);

        formData.append('longitude', values?.longitude);
        formData.append('latitude', values?.latitude);

        formData.append('status_id', values?.status_id);

        // if (lakeGeometry) {
        //   formData.append('geom', JSON.stringify(lakeGeometry));
        // }

        if (selectedLake) {
          formData.append('geom', JSON.stringify(selectedLake.geometry))
        }

        lakeUpdate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
            console.log(selectedLake, "SELECTERERD")
            if (selectedLake?.id) {
              const parsedId = parseInt(selectedLake.id.split('.')[1]);
              setConvertLakeId(parsedId);
              setIsEditShape(true)
            }
          })
          .catch((error) => {
            console.log(error)
            toastr.error(error?.data || "Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
        setResetFiles(true);

      } else {
        const formData = new FormData();

        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('location', values?.location);
        formData.append('cmn_lake_type', values?.cmn_lake_type);
        formData.append('sea_level_m', values?.sea_level_m);

        formData.append('basin_code', values?.basin_code);
        formData.append('au1_code', values?.au1_code);
        formData.append('au2_code', values?.au2_code);
        formData.append('au3_code', values?.au3_code);

        formData.append('longitude', values?.longitude);
        formData.append('latitude', values?.latitude);

        // if (lakeGeometry) {
        //   formData.append('geom', JSON.stringify(lakeGeometry));
        // }

        if (selectedLake) {
          formData.append('geom', JSON.stringify(selectedLake.geometry))
        }

        if (lakeId) {
          const parsedId = parseInt(lakeId.split('.')[1]);
          setConvertLakeId(parsedId);
        }

        lakeCreate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай үүслээ!", "Амжилттай");
            const formShapeData = new FormData();
            formShapeData.append('id', lakeConvertId);
            formShapeData.append('is_edit', isEditShape);
            lakeShapeUpdate(formShapeData)
          })
          .catch((error) => {
            toastr.error(error?.data || "Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
        toastr.success("Мэдээлэл амжилттай нэмэгдлээ!", "Амжилттай");

        setResetFiles(true);
      }
      validation.resetForm();
      toggle();
    },
  });

  const handleOnLakeSelected = ({ lake, longitude, latitude }) => {
    setSelectedLake(lake);
    // const code = lake?.id?.split('.')?.[1];
    // if (code) {
    //   validation.setFieldValue('code', code);
    // }
    validation.setFieldValue('name', lakeOne?.name || lake?.properties?.namemon || "")

    validation.setFieldValue('latitude', latitude.toFixed(6));
    validation.setFieldValue('longitude', longitude.toFixed(6));
  };

  useEffect(() => {
    setLakeList(data?.data)
    setLoading(false)
    setLakeCount(lakeList?.length)
    setCustomPagination(data?.pagination)
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;

    setCustomQuery(tempQuery)
  }, [data, lakeList, customPageSize, customPageLength, customPagination, searchField])

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setLakeOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const lakeData = arg;
    setLakeOne({
      id: lakeData.id,
      code: lakeData.code,
      name: lakeData.name,
      location: lakeData.location,
      sea_level_m: lakeData.sea_level_m,
      cmn_lake_type: lakeData.cmn_lake_type,

      basin_code: lakeData.basin_code,
      au1_code: lakeData.au1_code,
      au2_code: lakeData.au2_code,
      au3_code: lakeData.au3_code,

      longitude: lakeData.longitude,
      latitude: lakeData.latitude,

      status_id: lakeData.status_id,
    });

    setIsEdit(false);
    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (lakeData) => {
    setLakeOne(lakeData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (lakeOne) {
      lakeDelete(lakeOne.id)
        .unwrap()
        .then((response) => {
          toastr.success("Мэдээлэл амжилттай устгагдлаа!", "Амжилттай");
        })
        .catch((error) => {
          toastr.error(error?.data || "Амжилтгүй!", "Амжилтгүй");
        })
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setLakeOne(null);
    toggle();
  };
  useEffect(() => {
    const formShapeData = new FormData();
    if (lakeConvertId && isEditShape) {
      formShapeData.append('id', lakeConvertId);
      formShapeData.append('is_edit', isEditShape);
      lakeShapeUpdate(formShapeData);
      console.log('lake updated', lakeConvertId, isEditShape);
    }
  }, [lakeConvertId, isEditShape]);

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Байршил",
        accessorKey: "location",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Сав газрын дугаар",
        accessorKey: "basin_code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Далайн түвшин /м/",
        accessorKey: "sea_level_m",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Газрын насжилт",
      //   accessorKey: "geological_age_index",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      {
        header: "Төлөв",
        accessorKey: "status.name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          const row = cellProps.row.original
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">

              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/surface/water/lake/show/${row.id}`} className="btn btn-sm btn-soft-primary" id="viewtooltip">
                  <i className="mdi mdi-eye-outline"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  Харах
                </UncontrolledTooltip>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  id="deletetooltip"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete(row);
                  }}
                >
                  <i className="mdi mdi-delete-outline" />
                </Link>
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Устгах
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  id="edittooltip"
                  onClick={(event: any) => {
                    event.preventDefault();
                    handleJobClick(row);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" />
                </Link>
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Засах
                </UncontrolledTooltip>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleJobClick]
  );

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={lakeOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={lake} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(lakeCount)}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  handleJobClicks();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={lakeList || ""}
              isCustomPageSize={true}
              // isGlobalFilter={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          toggle();
        }}>
          <div className="h5 modal-title" id="staticBackdropLabel">{!!isEdit ? "Нуур тойром мэдээлэл засах" : "Нуур тойром мэдээлэл нэмэх"}</div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Нуур, тойрмын бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code && validation.errors.code ? (
                    <FormFeedback status="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Нуур (тойром)-ын нэр *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Нуур (тойром)-ын байршил *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Далайн түвшин /м/ *</Label>
                  <Input
                    name="sea_level_m"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sea_level_m || ""}
                    invalid={
                      validation.touched.sea_level_m && validation.errors.sea_level_m
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                    <FormFeedback status="invalid">
                      {validation.errors.sea_level_m}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label >Солбицол Х</Label>
                  <Input
                    disabled
                    name="latitude"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.latitude || ""}
                    invalid={
                      validation.touched.latitude && validation.errors.latitude
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.latitude && validation.errors.latitude ? (
                    <FormFeedback status="invalid">
                      {validation.errors.latitude}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label >Солбицол У</Label>
                  <Input
                    disabled
                    name="longitude"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.longitude || ""}
                    invalid={
                      validation.touched.longitude && validation.errors.longitude
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.longitude && validation.errors.longitude ? (
                    <FormFeedback status="invalid">
                      {validation.errors.longitude}
                    </FormFeedback>
                  ) : null}
                </div>

                {!!isEdit &&
                  <StatusSelect
                    formik={validation}
                    name="status_id"
                  />
                }
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label>	Нуурын төрөл *</Label>
                  <Input
                    name="cmn_lake_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_lake_type || ""}
                    invalid={
                      validation.touched.cmn_lake_type &&
                        validation.errors.cmn_lake_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {commonLake?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}
                  </Input>
                  {validation.touched.cmn_lake_type &&
                    validation.errors.cmn_lake_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_lake_type}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <AuInputList
                    formik={validation}
                    showBasin
                    showAu1
                    showAu2
                    showAu3
                  />
                </div>

                {lakeOne?.id &&
                  <div className="mb-3">
                    <Label>	Зураг оруулах </Label>
                    <ImageUploader
                      tableName="lake"
                      connectionId={lakeOne.id}
                      valueGroup="test"
                      accept={[".jpeg", ".jpg", ".png"]}
                      multiple
                    />
                  </div>
                }
              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>
                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} onResetValueChange={setResetFiles} fileType={"multipolygon"} />
              </Row>
            }
            <Row>
              <Col lg="12">
                <div className='mapTypeSelection'>
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                </div>
                <LakeSelectorMap baseMap={baseMap} initialLongitude={lakeOne?.longitude} initialLatitude={lakeOne?.latitude} onLakeSelected={handleOnLakeSelected} />
              </Col>
            </Row>
          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>

      </Modal>
    </React.Fragment>
  );
};

export default Detail;
